module.exports = __webpack_public_path__ + "img/yyzz.397ff244.jpg";